import { MpsSidebarTemplate } from '@mps/mps-kit/mps-sidebar';

export const hpc_sidebar_factory_templates: Record<string, () => MpsSidebarTemplate> = {
  'sidebar:demo': () =>
    ({
      id: 'sidebar:demo',
      title: 'hello mama',
      showTitleSection: true,
      showCloseButton: true,
      stylex: {
        xsBackground: 'color.bg-gaz',
        xsBorderRadius: 'size.large',
        style: {
          border: '2px  solid green',
        },
      },
    }) satisfies MpsSidebarTemplate,

  'sidebar:hpc': () =>
    ({
      id: 'sidebar:hpc',
      title: 'hello mama',
      showTitleSection: true,
      showCloseButton: true,
      stylex: {
        xsBackground: 'var(--mps-clr-bg-card-ultra-light-grey)',
      },
    }) satisfies MpsSidebarTemplate,
};
